import React, { useEffect, useState,useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import './horizonTable.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../forms/themeCheckbox.css";
import {
  adminEditLabelStyle,
  adminEditInputStyle,
  parseSiteRegisterDate,
  formatSiteRegisterDate,
  formatIsoDate,
  siteRegisterDatePickerProps,
  adminEditModalOverlayStyle,
  adminEditModalContentStyle,
  adminEditModalHeaderStyle,
  adminEditModalTitleStyle,
  adminEditModalBodyStyle,
  adminEditModalFooterStyle,
  adminEditCancelBtnStyle,
  adminEditSaveBtnStyle,
  adminEditSigBoxStyle,
  ADMIN_THEME,
} from "./adminEditModalTheme";

import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import onsiteproLogo from '../../assets/logo2 2.png';
import AdminTaylorImportModal, { adminIsPrimaryAdmin } from "./AdminTaylorImportModal";
import { ensureFormUuid } from "../../utils/formUuid";
import { buildSharePointFileName, toDdMmYyyy, addedByName } from "../../utils/formPdfHelpers";

import { canEditDeleteRecords } from "../../utils/rolePermissions";
function UkpnTbsPage() {
  const canEditDelete = canEditDeleteRecords();
  // Dynamic signature blocks for editing
  const [editSignatureBlocks, setEditSignatureBlocks] = useState([]);
  const signatureRefs = React.useRef({});
  const [forms, setForms] = useState([]);
  const [appUsers, setAppUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const isAdminUser = adminIsPrimaryAdmin();
  const [deleteId, setDeleteId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [editMainSignature, setEditMainSignature] = useState("");
  const editMainSigCanvasRef = useRef(null);
  const [showGroupMemberDeleteModal, setShowGroupMemberDeleteModal] = useState(false);
  const [groupMemberToDelete, setGroupMemberToDelete] = useState(null);

  // SharePoint upload modal state
  const [showSharePointUploadModal, setShowSharePointUploadModal] = useState(false);
  const [sharePointUploadRecord, setSharePointUploadRecord] = useState(null);
  const [sharePointPhaseType, setSharePointPhaseType] = useState('phase');
  const [sharePointPhaseNumber, setSharePointPhaseNumber] = useState('15');
  const [sharePointNetwork, setSharePointNetwork] = useState('');
  const [pendingDirectUpload, setPendingDirectUpload] = useState(false);
  useEffect(() => {
    if (pendingDirectUpload && sharePointUploadRecord) {
      setPendingDirectUpload(false);
      // eslint-disable-next-line no-use-before-define
      handleSharePointUpload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingDirectUpload, sharePointUploadRecord]);
  const [uploadingKey, setUploadingKey] = useState(null);

  // Main signature handlers for edit modal
  const clearEditMainSignature = () => {
    if (editMainSigCanvasRef.current) {
      editMainSigCanvasRef.current.clear();
    }
    setEditMainSignature("");
    setEditForm(prev => ({ ...prev, signature: "" }));
  };

  const saveEditMainSignature = () => {
    if (editMainSigCanvasRef.current && !editMainSigCanvasRef.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = editMainSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditMainSignature(sig);
      setEditForm(prev => ({ ...prev, signature: sig }));
    }
  };

  // Helper function to convert DD/MM/YYYY to YYYY-MM-DD for HTML date input
  const convertDateFormat = (dateStr) => {
    if (!dateStr) return "";
    // Handle DD/MM/YYYY format
    if (dateStr.includes('/')) {
      const parts = dateStr.split('/');
      if (parts.length === 3) {
        const day = parts[0].padStart(2, '0');
        const month = parts[1].padStart(2, '0');
        const year = parts[2];
        return `${year}-${month}-${day}`;
      }
    }
    // Handle YYYY-MM-DD format (already correct)
    if (dateStr.includes('-')) {
      return dateStr;
    }
    return dateStr;
  };

  // Group entries management functions
  const removeEditSignatureBlock = (blockId) => {
    if (editSignatureBlocks.length > 1) {
      setGroupMemberToDelete(blockId);
      setShowGroupMemberDeleteModal(true);
    } else {
      toast.warning("At least one group member is required!");
    }
  };

  const confirmRemoveEditSignatureBlock = () => {
    if (groupMemberToDelete !== null && editSignatureBlocks.length > 1) {
      const block = editSignatureBlocks.find(b => b.id === groupMemberToDelete);
      const memberName = block?.name || `Group Member`;
      setEditSignatureBlocks(editSignatureBlocks.filter(block => block.id !== groupMemberToDelete));
      // Clean up the ref
      if (signatureRefs.current[groupMemberToDelete]) {
        delete signatureRefs.current[groupMemberToDelete];
      }
      toast.success(`${memberName || 'Group member'} removed successfully!`);
      setShowGroupMemberDeleteModal(false);
      setGroupMemberToDelete(null);
    }
  };

  // Signature handlers for edit modal
  const clearEditSignature = (blockId) => {
    const ref = signatureRefs.current[blockId];
    if (ref && ref.current) {
      ref.current.clear();
    }
    setEditSignatureBlocks(prev => prev.map(block => 
      block.id === blockId ? { ...block, signature: "" } : block
    ));
  };

  const saveEditSignature = (blockId) => {
    const ref = signatureRefs.current[blockId];
    if (ref && ref.current && !ref.current.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = ref.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditSignatureBlocks(prev => {
        const updated = prev.map(block => 
          block.id === blockId ? { ...block, signature: sig } : block
        );
        return updated;
      });
    }
  };

  const handleEdit = (form) => {
    setEditForm({ ...form, formUuid: ensureFormUuid(form?.formUuid) });
    setEditMainSignature(form.signature || "");
    // Helper to robustly parse array or stringified array
    const parseField = (field) => {
      if (Array.isArray(field)) {
        // If array contains a single string that looks like a stringified array
        if (field.length === 1 && typeof field[0] === 'string' && field[0].startsWith('[') && field[0].endsWith(']')) {
          let inner = field[0];
          try {
            const parsed = JSON.parse(inner);
            if (Array.isArray(parsed)) return parsed;
          } catch {
            return inner.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, ''));
          }
        }
        return field;
      }
      if (typeof field === 'string' && field.startsWith('[') && field.endsWith(']')) {
        let inner = field;
        try {
          const parsed = JSON.parse(inner);
          if (Array.isArray(parsed)) return parsed;
        } catch {
          return inner.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, ''));
        }
      }
      return [field || ""];
    };
    let names = parseField(form.nameGroup);
    let dates = parseField(form.dateGroup);
    let times = parseField(form.timeGroup);
    let sigs = parseField(form.signatureGroup);
    
    // Debug logging

    // Find the actual number of items by counting non-empty values
    // Only create blocks for items that have data in ALL required fields
    const actualItems = [];
    const maxLength = Math.max(names.length, dates.length, times.length, sigs.length);
    
    for (let i = 0; i < maxLength; i++) {
      const name = names[i] || "";
      const date = dates[i] || "";
      const time = times[i] || "";
      const sig = sigs[i] || "";
      
      // Only create a block if ALL required fields have data
      if (name.trim() && date.trim() && time.trim() && sig.trim()) {
        actualItems.push({
          name: name.trim(),
          date: date.trim(),
          time: time.trim(),
          signature: sig.trim()
        });
      }
    }
    
    // Ensure we have at least one block if no complete data exists
    if (actualItems.length === 0) {
      actualItems.push({
        name: "",
        date: "",
        time: "",
        signature: ""
      });
    }
    
    // Create blocks for each complete item
    const blocks = actualItems.map((item, idx) => {
      const id = `${form._id || "new"}-tbs-${idx}`;
      if (!signatureRefs.current[id]) signatureRefs.current[id] = React.createRef();
      
      return {
        id,
        name: item.name,
        date: convertDateFormat(item.date),
        time: item.time,
        signature: item.signature,
      };
    });
    
    setEditSignatureBlocks(blocks);
    setShowEditModal(true);
    // Load signatures after modal is fully rendered
    setTimeout(() => {
      // Load main signature
      if (editMainSigCanvasRef.current && form.signature) {
        editMainSigCanvasRef.current.clear();
        let sigSrc = form.signature;
        if (typeof sigSrc === 'string' && !sigSrc.startsWith('data:image')) {
          sigSrc = 'data:image/png;base64,' + sigSrc;
        }
        const img = new window.Image();
        img.onload = () => {
          if (editMainSigCanvasRef.current) {
            const canvas = editMainSigCanvasRef.current.getCanvas();
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
            const x = (canvas.width - img.width * scale) / 2;
            const y = (canvas.height - img.height * scale) / 2;
            ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
          }
        };
        img.onerror = () => {
          console.error('Failed to load main signature image');
        };
        img.src = sigSrc;
      }
      
      blocks.forEach((block, index) => {
        const ref = signatureRefs.current[block.id];
        if (block.signature && ref && ref.current) {
          ref.current.clear();
          let sigSrc = block.signature;
          
          // Ensure proper data URL format
          if (typeof sigSrc === 'string') {
            if (!sigSrc.startsWith('data:image')) {
              sigSrc = 'data:image/png;base64,' + sigSrc;
            }
          }
          
          const img = new window.Image();
          img.onload = () => {
            if (ref.current) {
              const canvas = ref.current.getCanvas();
              const ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              
              // Draw the image with proper scaling to maintain aspect ratio
              const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
              const x = (canvas.width - img.width * scale) / 2;
              const y = (canvas.height - img.height * scale) / 2;
              
              ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
            }
          };
          img.onerror = () => {
            console.error('Failed to load signature image for block:', block.id, 'Source:', sigSrc.substring(0, 100) + '...');
          };
          img.src = sigSrc;
        } else if (ref && ref.current) {
          ref.current.clear();
        }
      });
    }, 500);
  };
  const handleEditChange = (field, value) => {
    setEditForm(prev => ({ ...prev, [field]: value }));
  };
  const handleEditSave = async () => {
    // Basic validation
    if (!editForm.name || !editForm.position) {
      toast.error("All required fields must be filled");
      return;
    }
    
    // Force save main signature before saving the form
    if (editMainSigCanvasRef.current && !editMainSigCanvasRef.current.isEmpty()) {
      const canvas = editMainSigCanvasRef.current.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditForm(prev => ({ ...prev, signature: sig }));
    }
    
    // Force save all signatures before saving the form
    const updatedBlocks = editSignatureBlocks.map(block => {
      const ref = signatureRefs.current[block.id];
      if (ref && ref.current && !ref.current.isEmpty()) {
        const canvas = ref.current.getCanvas();
        const sig = canvas.toDataURL("image/png");
        return { ...block, signature: sig };
      }
      return block;
    });
    
    // Update the state with all signatures
    setEditSignatureBlocks(updatedBlocks);
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      
      // Convert blocks back to array-like strings using updated blocks
      const names = updatedBlocks.map(b => b.name).filter(Boolean);
      const dates = updatedBlocks.map(b => b.date).filter(Boolean);
      const times = updatedBlocks.map(b => b.time).filter(Boolean);
      const signatures = updatedBlocks.map(b => b.signature).filter(Boolean);
      
      // Convert dates back to DD/MM/YYYY format for storage
      const formattedDates = dates.map(dateStr => {
        if (dateStr.includes('-')) {
          // Convert YYYY-MM-DD back to DD/MM/YYYY
          const parts = dateStr.split('-');
          if (parts.length === 3) {
            return `${parts[2]}/${parts[1]}/${parts[0]}`;
          }
        }
        return dateStr;
      });
      
      // Format as array-like strings
      const nameGroup = names.length > 0 ? `[${names.join(', ')}]` : "";
      const dateGroup = formattedDates.length > 0 ? `[${formattedDates.join(', ')}]` : "";
      const timeGroup = times.length > 0 ? `[${times.join(', ')}]` : "";
      // Format signatures with quotes since they contain special characters
      const signatureGroup = signatures.length > 0 ? `[${signatures.map(sig => `"${sig}"`).join(',')}]` : "";
      
      // Get user details for saving firstName and lastName
      const userId = localStorage.getItem("userId");
      const user = userId ? appUsers.find(u => String(u._id) === String(userId)) : null;
      const addedByFirstName = user ? user.firstName : '';
      const addedByLastName = user ? user.lastName : '';
      
      const updatedForm = { 
        ...editForm, 
        formUuid: ensureFormUuid(editForm.formUuid),
        addedByFirstName,
        addedByLastName,
        nameGroup, 
        dateGroup, 
        timeGroup, 
        signatureGroup 
      };
      const res = await fetch(baseUrl + `/api/ukpn-tbs/${editForm._id}` , {
        method: "PUT",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
        body: JSON.stringify(updatedForm)
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setForms(forms.map(f => f._id === editForm._id ? { ...f, ...updatedForm } : f));
        setShowEditModal(false);
        toast.success("Updated successfully");
      } else {
        toast.error(data.message || "Failed to update");
      }
    } catch {
      toast.error("Failed to update");
    }
  };
  useEffect(() => {
    async function fetchForms() {   
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + "/api/ukpn-tbs", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.data)) {
          setForms(data.data);
        } else {
          setForms([]);
        }
      } catch {
        setForms([]);
      }
    }
    async function fetchAppUsers() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + "/api/app-users", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.data)) {
          setAppUsers(data.data);
        } else {
          setAppUsers([]);
        }
      } catch {
        setAppUsers([]);
      }
    }
    fetchForms();
    fetchAppUsers();
  }, []);
  const filtered = forms.filter(f => {
    const fields = [f.name, f.position].map(val => (val || '').toLowerCase());
    const searchWords = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (searchWords.length === 0) return true;
    return searchWords.every(word => fields.some(field => field.includes(word)));
  });
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const paged = filtered.slice().slice((page-1)*pageSize, page*pageSize);
  const formatDateForDisplay = (d) => {
    if (!d) return "—";
    const x = new Date(d);
    return isNaN(x.getTime()) ? d : x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };
  
  // Reset page to 1 if current page is beyond available pages
  if (filtered.length === 0 && page > 1) {
    setPage(1);
  }
  // SharePoint Upload Handler
  const handleSharePointUpload = async () => {
    const locationForUpload = (sharePointUploadRecord?.name || '').trim();

    if (!locationForUpload) {
      toast.error('Name is missing for this record.');
      return;
    }

    if (sharePointPhaseType === 'phase' && (!sharePointNetwork || sharePointNetwork.trim() === '')) {
      toast.error('Please select an area (EPN, LPN, or SPN)');
      return;
    }

    const payloadPhaseType = sharePointPhaseType === 'phase' ? 'phase' : 'non-phase';
    const payloadNetwork = sharePointPhaseType === 'phase' ? sharePointNetwork : '';
    const payloadPhaseNumber = sharePointPhaseType === 'phase' ? sharePointPhaseNumber : '';

    setShowSharePointUploadModal(false);

    await generatePDF(sharePointUploadRecord, {
      uploadOnly: true,
      phaseType: payloadPhaseType,
      phaseNumber: payloadPhaseNumber,
      network: payloadNetwork,
      siteName: locationForUpload,
      onSuccess: () => {
        setSharePointUploadRecord(null);
        setSharePointPhaseType('phase');
        setSharePointPhaseNumber('15');
        setSharePointNetwork('');
      },
      onError: () => {}
    });
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
      const token = localStorage.getItem("token");
      const res = await fetch(baseUrl + `/api/ukpn-tbs/${deleteId}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setForms(forms.filter(f => f._id !== deleteId));
        toast.success("Deleted successfully!");
      } else {
        toast.error(data.message || "Failed to delete");
      }
    } catch {
      toast.error("Failed to delete");
    }
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const generatePDF = async (record, options = {}) => {
    const shouldUploadToSharePoint = options.uploadOnly === true;
    const uploadConfig = shouldUploadToSharePoint ? {
      phaseType: options.phaseType || 'non-phase',
      phaseNumber: options.phaseNumber || '',
      network: options.network || '',
      siteName: options.siteName || '',
      onSuccess: options.onSuccess,
      onError: options.onError
    } : null;
    
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      
      // Modern color scheme
      const primaryColor = [139, 22, 52]; // #8b1634
      
      // Helper function to draw modern rounded rectangle
      const drawRoundedRect = (x, y, width, height, radius, fillColor, strokeColor, hasShadow = false) => {
        if (hasShadow) {
          doc.setFillColor(0, 0, 0, 0.1);
          doc.roundedRect(x + 1, y + 1, width, height, radius, radius, 'F');
        }
        doc.setFillColor(...fillColor);
        doc.setDrawColor(...strokeColor);
        doc.setLineWidth(0.5);
        doc.roundedRect(x, y, width, height, radius, radius, 'FD');
      };
      
      // ---- HEADER SECTION ----
      const headerHeight = 30;
      drawRoundedRect(0, 0, pageWidth, headerHeight, 0, primaryColor, primaryColor);
      
      // ---- ADD HIGH-RES LOGO ----
      const addLogoToPDF = () => {
        return new Promise((resolve) => {
          const logoImg = new Image();
          logoImg.crossOrigin = 'anonymous';
          logoImg.onload = function () {
            try {
              const logoWidth = 70;
              const aspectRatio = logoImg.height / logoImg.width;
              const logoHeight = logoWidth * aspectRatio;
              const logoX = 10;
              const logoY = (headerHeight - logoHeight) / 2;
              
              const canvas = document.createElement('canvas');
              const scale = 2.5;
              canvas.width = logoImg.width * scale;
              canvas.height = logoImg.height * scale;
              const ctx = canvas.getContext('2d');
              ctx.scale(scale, scale);
              ctx.drawImage(logoImg, 0, 0);
              
              const highResDataUrl = canvas.toDataURL('image/png', 1.0);
              doc.addImage(highResDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight, '', 'NONE');
            } catch (error) {
              doc.setFillColor(255, 255, 255);
              doc.rect(10, 6, 60, 15, 'F');
              doc.setFont("helvetica", "bold");
              doc.setFontSize(10);
              doc.setTextColor(0, 0, 0);
              doc.text("TAYLOR TECHNOLOGY", 15, 12);
              doc.text("SYSTEMS LIMITED", 15, 17);
            }
            resolve();
          };
          logoImg.onerror = function () {
            doc.setFillColor(255, 255, 255);
            doc.rect(10, 6, 60, 15, 'F');
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text("TAYLOR TECHNOLOGY", 15, 12);
            doc.text("SYSTEMS LIMITED", 15, 17);
            resolve();
          };
          logoImg.src = onsiteproLogo;
        });
      };
      
      await addLogoToPDF();
      
      // ---- HEADER TEXT ----
      const titleX = 90;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(255, 255, 255);
      doc.text("UKPN TBS Report", titleX, 13);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text("TAYLOR TECHNOLOGY SYSTEMS LIMITED", titleX, 19);
      
      let yPosition = headerHeight + 10;
      
      // ---- Section 1: Basic Information ----
      doc.setFillColor(139, 22, 52);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      
      doc.rect(10, yPosition, pageWidth - 20, 8, "F");
      doc.text("1", 14, yPosition + 5.5);
      doc.text("Basic Information", 22, yPosition + 5.5);
      yPosition += 8;
      
      autoTable(doc, {
        startY: yPosition,
        columnStyles: {
          0: { cellWidth: 50 },
          1: { cellWidth: 140 },
        },
        head: [
          [
            { content: "Name:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.name || "", styles: { halign: "center" } },
          ],
          [
            { content: "Position:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.position || "", styles: { halign: "center" } },
          ],
        ],
        body: [],
        styles: {
          font: "helvetica",
          fontSize: 9,
          cellPadding: 3,
          overflow: "linebreak",
          valign: "middle",
        },
        theme: "grid",
        tableWidth: pageWidth - 20,
        margin: { left: 10 },
        headStyles: {
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        bodyStyles: {
          lineWidth: 0.2,
          textColor: [0, 0, 0],
        },
      });
      
      yPosition = doc.lastAutoTable.finalY + 2;
      
      // Helper function to add signature with proper sizing
      const addSignatureToPDF = async (signatureData, x, y, maxWidth, maxHeight) => {
          if (!signatureData) return;
          
          try {
            let sigSrc = signatureData;
            if (!sigSrc.startsWith('data:image')) {
              sigSrc = 'data:image/png;base64,' + sigSrc;
            }
            
            return new Promise((resolve) => {
              const sigImg = new Image();
              sigImg.crossOrigin = 'anonymous';
              
              sigImg.onload = () => {
                try {
                  const aspectRatio = sigImg.width / sigImg.height;
                  let imgWidth = maxWidth;
                  let imgHeight = maxWidth / aspectRatio;
                  
                  if (imgHeight > maxHeight) {
                    imgHeight = maxHeight;
                    imgWidth = maxHeight * aspectRatio;
                  }
                  
                  imgWidth = Math.min(imgWidth, maxWidth);
                  imgHeight = Math.min(imgHeight, maxHeight);
                  
                  const scale = 4;
                  const canvas = document.createElement('canvas');
                  canvas.width = Math.round(imgWidth * scale);
                  canvas.height = Math.round(imgHeight * scale);
                  const ctx = canvas.getContext('2d');
                  ctx.imageSmoothingEnabled = true;
                  ctx.imageSmoothingQuality = 'high';
                  ctx.fillStyle = '#FFFFFF';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                  ctx.drawImage(sigImg, 0, 0, sigImg.width, sigImg.height, 0, 0, canvas.width, canvas.height);
                  const highResDataUrl = canvas.toDataURL('image/png', 1.0);
                  doc.addImage(highResDataUrl, 'PNG', x, y, imgWidth, imgHeight, '', 'NONE');
                } catch (err) {
                  console.error('Error adding signature to PDF:', err);
                  try {
                    doc.addImage(sigSrc, 'PNG', x, y, maxWidth, maxHeight);
                  } catch (fallbackErr) {
                    console.error('Fallback signature addition also failed:', fallbackErr);
                  }
                }
                resolve();
              };
              
              sigImg.onerror = () => {
                console.error('Error loading signature image');
                resolve();
              };
              
              sigImg.src = sigSrc;
            });
          } catch (err) {
            console.error('Signature processing error:', err);
          }
        };
      
      // Add Main Signature within Section 1 (Basic Information)
      if (record.signature) {
        yPosition += 5;
        
        const boxWidth = pageWidth - 20;
        const boxHeight = 40;
        
        doc.setDrawColor(200, 200, 200);
        doc.setFillColor(248, 248, 248);
        doc.roundedRect(10, yPosition, boxWidth, boxHeight, 3, 3, "FD");
        
        doc.setTextColor(139, 22, 52);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("Main Signature", 15, yPosition + 8);
        
        const signatureMaxWidth = 50;
        const signatureMaxHeight = 22;
        const signatureX = pageWidth - 75;
        const signatureY = yPosition + 12;
        
        // Signature label
        doc.setFontSize(8);
        doc.setTextColor(139, 22, 52);
        doc.setFont("helvetica", "bold");
        doc.text("Signature:", signatureX, signatureY - 2);
        
        await addSignatureToPDF(record.signature, signatureX, signatureY, signatureMaxWidth, signatureMaxHeight);
        yPosition += boxHeight + 8;
      }
      
      // ---- Section 2: Group Signatures ----
      // Parse nameGroup, dateGroup, timeGroup, signatureGroup
      const parseField = (field) => {
        if (Array.isArray(field)) {
          if (field.length === 1 && typeof field[0] === 'string' && field[0].startsWith('[') && field[0].endsWith(']')) {
            let inner = field[0];
            try {
              const parsed = JSON.parse(inner);
              if (Array.isArray(parsed)) return parsed;
            } catch {
              return inner.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, ''));
            }
          }
          return field;
        }
        if (typeof field === 'string' && field.startsWith('[') && field.endsWith(']')) {
          let inner = field;
          try {
            const parsed = JSON.parse(inner);
            if (Array.isArray(parsed)) return parsed;
          } catch {
            return inner.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, ''));
          }
        }
        return field ? [field] : [];
      };
      
      let names = parseField(record.nameGroup);
      let dates = parseField(record.dateGroup);
      let times = parseField(record.timeGroup);
      let signatures = [];
      
      // Parse signatureGroup
      if (record.signatureGroup) {
        try {
          if (typeof record.signatureGroup === 'string' && record.signatureGroup.startsWith('[') && record.signatureGroup.endsWith(']')) {
            signatures = JSON.parse(record.signatureGroup);
            if (!Array.isArray(signatures)) {
              signatures = [signatures];
            }
          } else if (record.signatureGroup.includes(',')) {
            signatures = record.signatureGroup.split(',').map(s => {
              let cleaned = s.trim();
              if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
                cleaned = cleaned.slice(1, -1);
              } else if (cleaned.startsWith("'") && cleaned.endsWith("'")) {
                cleaned = cleaned.slice(1, -1);
              }
              return cleaned;
            }).filter(Boolean);
          } else {
            let cleaned = record.signatureGroup.trim();
            if (cleaned.startsWith('"') && cleaned.endsWith('"')) {
              cleaned = cleaned.slice(1, -1);
            } else if (cleaned.startsWith("'") && cleaned.endsWith("'")) {
              cleaned = cleaned.slice(1, -1);
            }
            signatures = [cleaned];
          }
        } catch (e) {
          console.error('Error parsing signatureGroup:', e);
          signatures = [];
        }
      }
      
      // Create blocks from parsed data
      const blocks = [];
      const maxLength = Math.max(names.length, dates.length, times.length, signatures.length);
      
      for (let i = 0; i < maxLength; i++) {
        const name = names[i] || "";
        const date = dates[i] || "";
        const time = times[i] || "";
        const signature = signatures[i] || "";
        
        if (name.trim() || date.trim() || time.trim() || signature.trim()) {
          blocks.push({ name, date, time, signature });
        }
      }
      
      // Display each signature block
      if (blocks.length > 0) {
        if (yPosition + 60 > pageHeight - 30) {
          doc.addPage();
          yPosition = 20;
        }
        
         doc.setFillColor(139, 22, 52);
         doc.setTextColor(255, 255, 255);
         doc.setFont("helvetica", "bold");
         doc.rect(10, yPosition, pageWidth - 20, 10, "F");
         doc.text("Section 2 : Group Signatures", 15, yPosition + 7);
        yPosition += 18;
        
        for (let i = 0; i < blocks.length; i++) {
          const block = blocks[i];
          
          // Check if we need a new page
          if (yPosition + 50 > pageHeight - 30) {
            doc.addPage();
            yPosition = 20;
          }
          
          // Signature box
          const boxWidth = pageWidth - 20;
          const boxHeight = 40;
          
          doc.setDrawColor(200, 200, 200);
          doc.setFillColor(248, 248, 248);
          doc.roundedRect(10, yPosition, boxWidth, boxHeight, 3, 3, "FD");
          
          doc.setTextColor(139, 22, 52);
          doc.setFontSize(10);
          doc.setFont("helvetica", "bold");
          doc.text(`Group Member ${i + 1}`, 15, yPosition + 8);
          
          // Name, Date, Time, and Signature layout
          doc.setFont("helvetica", "normal");
          doc.setFontSize(9);
          doc.setTextColor(0, 0, 0);
          const nameText = block.name ? `Name: ${block.name}` : "Name: -";
          const dateText = block.date ? `Date: ${block.date}` : "Date: -";
          const timeText = block.time ? `Time: ${block.time}` : "Time: -";
          doc.text(nameText, 15, yPosition + 18);
          doc.text(dateText, 15, yPosition + 26);
          doc.text(timeText, 15, yPosition + 34);
          
          // Signature on the right side
          if (block.signature) {
            const signatureMaxWidth = 50;
            const signatureMaxHeight = 22;
            const signatureX = pageWidth - 75;
            const signatureY = yPosition + 12;
            
            // Signature label
            doc.setFontSize(8);
            doc.setTextColor(139, 22, 52);
            doc.setFont("helvetica", "bold");
            doc.text("Signature:", signatureX, signatureY - 2);
            
            await addSignatureToPDF(block.signature, signatureX, signatureY, signatureMaxWidth, signatureMaxHeight);
          }
          
          yPosition += boxHeight + 8;
        }
      }
      
      // ---- Footer Section ----
      const footerY = pageHeight - 25;
      drawRoundedRect(0, footerY, pageWidth, 25, 0, [248, 249, 250], [200, 200, 200]);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(
        `Generated on: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`,
        20,
        footerY + 8
      );
      doc.text("Page 1 of 1", pageWidth - 30, footerY + 15);
      
      // Decorative border removed
      
      // Build filename and either save or upload
      const safeName = String(record.name || 'UKPNTBS').replace(/[\\/:"*?<>|]+/g, '-');
      
      let fileName;
      if (shouldUploadToSharePoint && uploadConfig) {
        // No site is captured on this form, so the name is person + date only.
        fileName = buildSharePointFileName([
          record.name || uploadConfig.siteName,
          toDdMmYyyy(record.dateGroup),
        ]);
      } else {
        fileName = `UKPNTBS_${safeName}.pdf`;
      }
      
      if (shouldUploadToSharePoint && uploadConfig) {
        try {
          const key = `${record._id || ''}|${record.name || ''}`;
          setUploadingKey(key);
          const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
          const dataUri = doc.output('datauristring');
          
          // Prepare SharePoint upload parameters
          const uploadParams = {
            fileName,
            fileBase64: dataUri,
            phaseType: uploadConfig.phaseType,
            phaseNumber: uploadConfig.phaseNumber,
            network: uploadConfig.network,
            siteName: uploadConfig.siteName, uploadContext: "hseq-forms-tablets", uploadSubFolder: "TBS UKPN"
          };
          
          const res = await fetch(`${apiUrl}/api/sharepoint/upload`, {
            method: 'POST',
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
            body: JSON.stringify(uploadParams)
          });
          if (res.status !== 204 && !res.ok) {
            let msg = 'SharePoint upload failed';
            try {
              const out = await res.json();
              msg = out?.message || msg;
            } catch (_) {}
            throw new Error(msg);
          }
          toast.success("PDF uploaded to SharePoint successfully!");
          if (uploadConfig.onSuccess) {
            uploadConfig.onSuccess();
          }
        } catch (err) {
          toast.error(err?.message || "SharePoint upload failed");
          if (uploadConfig.onError) {
            uploadConfig.onError(err);
          }
        } finally {
          setUploadingKey(null);
        }
      } else {
        doc.save(fileName);
        toast.success("Professional UKPN TBS PDF generated successfully!");
      }
    } catch (err) {
      console.error('Error generating PDF:', err);
      toast.error('Failed to generate PDF');
    }
  };

  // Robustly parse array fields for table display
  const parseArrayField = (field) => {
    if (Array.isArray(field)) {
      // If array contains a single string that looks like a stringified array
      if (field.length === 1 && typeof field[0] === 'string' && field[0].startsWith('[') && field[0].endsWith(']')) {
        let inner = field[0];
        try {
          // Remove extra quotes if present
          if (inner.includes('["')) {
            inner = inner.replace(/\\"/g, '"');
          }
          const parsed = JSON.parse(inner);
          if (Array.isArray(parsed)) {
            return parsed.join(', ');
          }
        } catch {
          return inner.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, '')).join(', ');
        }
      }
      // Otherwise, join array items
      return field.join(', ');
    }
    // If field is a string that looks like a stringified array
    if (typeof field === 'string' && field.startsWith('[') && field.endsWith(']')) {
      let inner = field;
      try {
        if (inner.includes('["')) {
          inner = inner.replace(/\\"/g, '"');
        }
        const parsed = JSON.parse(inner);
        if (Array.isArray(parsed)) {
          return parsed.join(', ');
        }
      } catch {
        return inner.slice(1, -1).split(',').map(s => s.trim().replace(/^"|"$/g, '')).join(', ');
      }
    }
    // Otherwise, return as is
    return field;
  };

  const formatArrayWithBrackets = (field) => {
    const value = parseArrayField(field);
    if (!value) return "";
    const str = String(value).trim();
    if (str.startsWith("[") && str.endsWith("]")) return str;
    return `[${str}]`;
  };

  return (
    <div style={{
      background: '#ffffff',
      borderRadius: '20px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      padding: '24px',
      marginBottom: '24px'
    }}>
      {/* Header Section */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#1a202c',
          margin: 0
        }}>UKPN TBS</h2>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          {isAdminUser && (
            <button
              type="button"
              onClick={() => setShowImportModal(true)}
              style={{
                background: "#8b1634",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 14px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              Import File
            </button>
          )}
          <div style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
          }}>
            <i className="fa fa-search" style={{
              position: 'absolute',
              left: '12px',
              color: '#8b1634',
              fontSize: '14px'
            }}></i>
            <input 
              type="text" 
              placeholder="Type to Search" 
              value={search} 
              onChange={e=>{ setSearch(e.target.value); setPage(1); }}
              style={{
                padding: '10px 12px 10px 36px',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                fontSize: '14px',
                outline: 'none',
                width: '250px',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#8b1634'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>
        </div>
      </div>

      {/* Table Container */}
      <div style={{
        overflowX: 'auto',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1.2fr 1.2fr 1fr 1fr 0.9fr 1.2fr',
          background: '#f7fafc',
          padding: '12px 16px',
          borderBottom: '1px solid #e2e8f0',
          gap: '16px',
          alignItems: 'center'
        }}>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Name</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Position</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Name Group</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Date Group</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Time Group</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Added By</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Updated Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Actions</div>
        </div>

        {/* Table Body */}
        <div>
          {paged.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#718096',
              fontSize: '16px'
            }}>No records found.</div>
          ) : paged.map((f, idx) => {
              // First check if firstName and lastName are saved in the record
              // If not, try to find user from appUsers array
              let userName = '-';
              if (f.addedByFirstName && f.addedByLastName) {
                userName = `${f.addedByFirstName} ${f.addedByLastName}`;
              } else {
                const user = appUsers.find(u => u._id === f.userId);
                userName = user ? `${user.firstName} ${user.lastName}` : (f.userId || '-');
              }
                return (
                <div 
                  key={f._id || idx}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1.2fr 1.2fr 1fr 1fr 0.9fr 1.2fr',
                    padding: '16px',
                    borderBottom: '1px solid #f1f5f9',
                    gap: '16px',
                    alignItems: 'center',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.name || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.position || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatArrayWithBrackets(f.nameGroup) || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatArrayWithBrackets(f.dateGroup) || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatArrayWithBrackets(f.timeGroup) || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{userName || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatDateForDisplay(f.updatedAt || f.createdAt)}</div>
                  <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                    {canEditDelete && (
                      <button 
                        onClick={()=>handleEdit(f)}
                        title="Edit"
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          padding: '6px',
                          borderRadius: '6px',
                          transition: 'background-color 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <i className="fa fa-edit" style={{color:'#22c55e', fontSize: '16px'}}></i>
                      </button>
                    )}
                    <button 
                      onClick={()=>generatePDF(f)}
                      title="Generate PDF"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <i className="fa fa-file-pdf-o" style={{color:'#dc2626', fontSize: '16px'}}></i>
                    </button>
                    {(() => { 
                      const k = `${f._id || ''}|${f.name || ''}`; 
                      const busy = uploadingKey === k; 
                      return (
                        <button 
                          onClick={()=>{
                            if (!busy) {
                              setSharePointUploadRecord(f);
                              setSharePointPhaseType('phase');
                              setSharePointPhaseNumber('15');
                              setSharePointNetwork('');
                              setSharePointPhaseType("non-phase"); setPendingDirectUpload(true);
                            }
                          }}
                          disabled={busy}
                          title={busy ? "Uploading..." : "Upload to SharePoint"}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: busy ? 'not-allowed' : 'pointer',
                            padding: '6px',
                            borderRadius: '6px',
                            transition: 'background-color 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: busy ? 0.6 : 1
                          }}
                          onMouseEnter={(e) => !busy && (e.currentTarget.style.backgroundColor = '#f0fdf4')}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                          <i className={busy ? "fa fa-spinner fa-spin" : "fa fa-upload"} style={{color:'#22c55e', fontSize: '16px'}}></i>
                        </button>
                      ); 
                    })()}
                    {canEditDelete && (
                      <button 
                        onClick={()=>handleDelete(f._id)}
                        title="Delete"
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          padding: '6px',
                          borderRadius: '6px',
                          transition: 'background-color 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <i className="fa fa-trash" style={{color:'#e53e3e', fontSize: '16px'}}></i>
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {/* Pagination */}
      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '18px',
        gap: '12px'
      }}>
        <button 
          disabled={page===1 || filtered.length === 0} 
          onClick={()=>setPage(page-1)}
          style={{
            padding: '8px 16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            background: (page===1 || filtered.length === 0) ? '#f7fafc' : '#ffffff',
            color: (page===1 || filtered.length === 0) ? '#a0aec0' : '#8b1634',
            cursor: (page===1 || filtered.length === 0) ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >Prev</button>
        <span style={{
          fontWeight: '700',
          color: '#8b1634',
          fontSize: '16px'
        }}>{page} / {totalPages}</span>
        <button 
          disabled={page===totalPages || filtered.length === 0} 
          onClick={()=>setPage(page+1)}
          style={{
            padding: '8px 16px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0',
            background: (page===totalPages || filtered.length === 0) ? '#f7fafc' : '#ffffff',
            color: (page===totalPages || filtered.length === 0) ? '#a0aec0' : '#8b1634',
            cursor: (page===totalPages || filtered.length === 0) ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >Next</button>
      </div>
      {/* Edit Modal */}
      {showEditModal && editForm && (
        <div className="modal fade show" style={adminEditModalOverlayStyle} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={adminEditModalContentStyle}>
              <div className="modal-header" style={adminEditModalHeaderStyle}>
                <h5 className="modal-title" style={adminEditModalTitleStyle}>Edit UKPN TBS</h5>
                <button type="button" className="btn-close btn-close-white" onClick={()=>setShowEditModal(false)}></button>
              </div>
              <div className="modal-body" style={adminEditModalBodyStyle}>
                <div className="row g-3 mb-1">
                  <div className="col-12 col-md-3">
                    <label style={adminEditLabelStyle}>Name</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.name} onChange={e=>handleEditChange('name', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-3">
                    <label style={adminEditLabelStyle}>Position</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.position} onChange={e=>handleEditChange('position', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-6">
                    <label style={adminEditLabelStyle}>Main Signature</label>
                    <div style={adminEditSigBoxStyle()}>
                        {editForm.signature ? (
                          <img
                            src={editForm.signature.startsWith('data:image')
                              ? editForm.signature
                              : `data:image/png;base64,${editForm.signature}`}
                            alt="Main Signature"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100px',
                              objectFit: 'contain',
                              border: '1px solid #ddd',
                              borderRadius: '8px',
                              padding: '4px',
                              backgroundColor: 'white',
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div style={{ color: '#888', fontSize: '14px', padding: '20px' }}>
                            Signature (Disabled in Edit)
                          </div>
                        )}
                      </div>
                  </div>
                </div>
                {editSignatureBlocks.map((block, idx) => (
                  <div key={block.id} className="card mb-3" style={{ border: '1px solid #e8e8e8', borderRadius: 12, overflow: 'hidden' }}>
                    <div className="card-body" style={{ padding: '16px 20px' }}>
                      <div className="mb-3">
                        <h6 style={{ color: ADMIN_THEME, margin: 0, fontWeight: 600 }}>Group Member {idx + 1}</h6>
                      </div>
                      <div className="row g-3 mb-1">
                        <div className="col-12 col-md-2">
                          <label style={adminEditLabelStyle}>Name</label>
                          <input type="text" className="form-control" style={adminEditInputStyle} value={block.name || ""} onChange={e => {
                            const val = e.target.value;
                            setEditSignatureBlocks(prev => prev.map((b, i) => i === idx ? { ...b, name: val } : b));
                          }} />
                        </div>
                        <div className="col-12 col-md-2">
                          <label style={adminEditLabelStyle}>Date</label>
                          <div className="site-register-datepicker-wrap">
                            <DatePicker
                              {...siteRegisterDatePickerProps}
                              selected={parseSiteRegisterDate(block.date)}
                              onChange={(d) => {
                                const val = formatIsoDate(d);
                                setEditSignatureBlocks(prev => prev.map((b, i) => i === idx ? { ...b, date: val } : b));
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-2">
                          <label style={adminEditLabelStyle}>Time</label>
                          <input type="time" className="form-control" style={adminEditInputStyle} value={block.time || ""} onChange={e => {
                            const val = e.target.value;
                            setEditSignatureBlocks(prev => prev.map((b, i) => i === idx ? { ...b, time: val } : b));
                          }} />
                        </div>
                        <div className="col-12 col-md-6">
                          <label style={adminEditLabelStyle}>Signature</label>
                          <div style={adminEditSigBoxStyle()}>
                        {block.signature ? (
                          <img
                            src={block.signature.startsWith('data:image')
                              ? block.signature
                              : `data:image/png;base64,${block.signature}`}
                            alt="Signature"
                            style={{
                              maxWidth: '100%',
                              maxHeight: '100px',
                              objectFit: 'contain',
                              border: '1px solid #ddd',
                              borderRadius: '8px',
                              padding: '4px',
                              backgroundColor: 'white',
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div style={{ color: '#888', fontSize: '14px', padding: '20px' }}>
                            Signature (Disabled in Edit)
                          </div>
                        )}
                      </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end mt-3">
                        <button
                          type="button"
                          className="btn btn-sm"
                          onClick={() => removeEditSignatureBlock(block.id)}
                          disabled={editSignatureBlocks.length === 1}
                          style={{
                            borderRadius: '50%',
                            width: '30px',
                            height: '30px',
                            padding: 0,
                            background: editSignatureBlocks.length === 1 ? '#eaeaea' : ADMIN_THEME,
                            color: editSignatureBlocks.length === 1 ? '#aaa' : '#fff',
                            border: 'none'
                          }}
                          title="Remove Group Member"
                        >
                          <i className="fa fa-minus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="modal-footer" style={adminEditModalFooterStyle}>
                <button type="button" className="btn" style={adminEditCancelBtnStyle} onClick={()=>setShowEditModal(false)}>Cancel</button>
                <button type="button" className="btn" style={adminEditSaveBtnStyle} onClick={handleEditSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Group Member Delete Confirmation Modal */}
      {showGroupMemberDeleteModal && groupMemberToDelete !== null && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'500px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Remove Group Member</h5>
                <button type="button" className="btn-close" onClick={()=>{
                  setShowGroupMemberDeleteModal(false);
                  setGroupMemberToDelete(null);
                }}></button>
              </div>
              <div className="modal-body">
                {(() => {
                  const block = editSignatureBlocks.find(b => b.id === groupMemberToDelete);
                  const memberName = block?.name 
                    ? block.name 
                    : `Group Member`;
                  return (
                    <p>Are you sure you want to remove <strong>{memberName || 'this group member'}</strong>?</p>
                  );
                })()}
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={()=>{
                    setShowGroupMemberDeleteModal(false);
                    setGroupMemberToDelete(null);
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger" 
                  onClick={confirmRemoveEditSignatureBlock}
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SharePoint Upload Modal */}
      {showSharePointUploadModal && sharePointUploadRecord && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'600px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Upload to SharePoint</h5>
                <button type="button" className="btn-close" onClick={()=>{
                  setShowSharePointUploadModal(false);
                  setSharePointUploadRecord(null);
                  setSharePointPhaseType('phase');
                  setSharePointPhaseNumber('15');
                  setSharePointNetwork('');
                }}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="mb-3 col-12">
                    <label className="form-label fw-semibold">Type <span style={{color:'red'}}>*</span></label>
                    <select 
                      className="form-select" 
                      value={sharePointPhaseType}
                      onChange={(e) => {
                        setSharePointPhaseType(e.target.value);
                        if (e.target.value === 'non-phase') {
                          setSharePointNetwork('');
                        }
                      }}
                    >
                      <option value="phase">Phase</option>
                      <option value="non-phase">Non Phase</option>
                    </select>
                  </div>
                  
                  {sharePointPhaseType === 'phase' && (
                    <>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Phase Number <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointPhaseNumber}
                          onChange={(e) => {
                            setSharePointPhaseNumber(e.target.value);
                          }}
                        >
                          <option value="15">Phase 15 (2025)</option>
                          <option value="16">Phase 16 (2026)</option>
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Area <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointNetwork}
                          onChange={(e) => {
                            setSharePointNetwork(e.target.value);
                          }}
                        >
                          <option value="">Select Area</option>
                          <option value="EPN">EPN</option>
                          <option value="LPN">LPN</option>
                          <option value="SPN">SPN</option>
                        </select>
                      </div>
                    </>
                  )}
                  
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={()=>{
                    setShowSharePointUploadModal(false);
                    setSharePointUploadRecord(null);
                    setSharePointPhaseType('phase');
                    setSharePointPhaseNumber('15');
                    setSharePointNetwork('');
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn" 
                  style={{background:'#8b1634', color:'#fff', fontWeight:600}}
                  onClick={handleSharePointUpload}
                >
                  Upload to SharePoint
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AdminTaylorImportModal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        title="Upload UKPN TBS File"
        importPath="ukpn-tbs/import-form"
        isAdminUser={isAdminUser}
        onImported={({ insertedRow }) => {
          if (insertedRow && insertedRow._id) {
            setForms(prev => [insertedRow, ...prev]);
            setPage(1);
          }
        }}
      />

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'1200px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Delete Confirmation</h5>
                <button type="button" className="btn-close" onClick={()=>setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete this record?
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={confirmDelete}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UkpnTbsPage;
